import { ReactNode } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  icon: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.error.main,
  },
}));

export interface ScaffolderFieldErrorProps {
  message: ReactNode;
}

/** Inline validation message rendered as a scaffolder field's helper text. */
export const ScaffolderFieldError = ({
  message,
}: ScaffolderFieldErrorProps) => {
  const { classes } = useStyles();

  return (
    <Box component="span" className={classes.container}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography variant="caption" color="error" component="span">
        {message}
      </Typography>
    </Box>
  );
};
